import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';

import { Button } from '@vds/buttons';
import { Line } from '@vds/lines';
import { TitleLockup } from '@vds/type-lockups';
import { Body } from '@vds/typography';

import { Margin } from '../styles';

const SessionModalContent = (props) => (
  <div className="modalOverlay" style={{ position: 'relative', zIndex: '1' }}>
    <div id={props.sessionTimedOut ? 'sessionTimeOut' : 'sessionWarning'}>
      <Row>
        <Col xs={12} sm={12} lg={12}>
          <Margin bottom={props.isMobileDevice ? '10px' : '160px'}>
            <TitleLockup
              data={{
                title: {
                  bold: true,
                  size: 'titleSmall',
                  primitive: 'h1',
                  children: props.title,
                },
              }}
            />
          </Margin>

          {!props.isMobileDevice && <Line type="primary" surface="light" />}
        </Col>
        <Col xs={12} sm={12} lg={12}>
          <Margin top={props.isMobileDevice ? '0px' : '10px'}>
            <Body size="large" primitive="p">
              {props.description}
            </Body>
          </Margin>

          {!props.isMobileDevice && (
            <Margin top="10px" left="20px" bottom="10px">
              <Button
                use="primary"
                role="button"
                data-analyticstrack="Session_Continue"
                onClick={(e) => (props.sessionTimedOut === false ? props.sessionKeepAlive(e) : props.onLogoff(e))}
              >
                {props.buttonText}
              </Button>
            </Margin>
          )}
        </Col>
      </Row>
    </div>
  </div>
);

SessionModalContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  sessionTimedOut: PropTypes.bool,
  onLogoff: PropTypes.func,
  sessionKeepAlive: PropTypes.func,
};

export default SessionModalContent;
